// i18next-extract-mark-ns-start Footer
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { fontSizes, Icon } from '../v2/styledComponents';
import { tabletThresholdPixels, colors } from './styledComponents';
import instagramWhite from '../../../assets/footer/instagram.svg';
import instagramNavy from '../../../assets/social/instagram.navy.svg';
import { mobileThresholdPixels } from '../v4/styledComponents';
// import MobileApps from './MobileApps';

const StyledIcon = styled(Icon)`
  margin: 0;
  width: 46px;
  height: 46px;
  @media (max-width: ${tabletThresholdPixels}) {
    display: flex;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    display: flex;
    margin: 0 auto 40px;
  }
`;

const Text = styled.p`
  font-family: Roboto;
  font-size: ${fontSizes.m};
  color: ${(props) => props.black ? colors.black : colors.white};
  margin: ${(props) => props.marginTop ? '30px' : 0} 0 15px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
    padding: auto 0;
    margin: 0 15px 0 30px;
    }
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 14px;
    margin: 0 0 15px;
  }
`;

const FooterMobileAndSocial = ({ inverse }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* <Text black={inverse}>{t('Téléchargez notre app')}</Text>
      <MobileApps /> */}
      <Text black={inverse} marginTop>{t('Laissez-vous inspirer')}</Text>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.instagram.com/tilli.jointhecycle/"
      >
        <StyledIcon
          src={inverse ? instagramNavy : instagramWhite}
          alt={t('page instagram de Tilli une retoucherie à domicile')}
        />
      </a>
    </>
  );
};

FooterMobileAndSocial.propTypes = {
  inverse: PropTypes.bool,
};

FooterMobileAndSocial.defaultProps = {
  inverse: false,
};

export default FooterMobileAndSocial;
